export function mergeEvent(event: Event | Record<string, unknown>, payload: Record<string, unknown>): Event {
  // isTrusted must be filtered to avoid this error "Cannot set property isTrusted of #<d> which has only a getter"
  // type must be filtered for the same reason
  const { isTrusted, type, ...filteredPayload } = payload;

  return Object.assign(event, filteredPayload) as Event;
}
